import styled from 'styled-components';
import { backgroundColors, borderColors, colors, textColors } from 'ui/theme';

export const Fieldset = styled.fieldset`
  /** Remove default fieldset element styles */
  border: none;
  margin: 0;
  padding: 0;
  min-width: unset;
`;

export const Flex = styled.div`
  display: inline-flex;
  > *:not(:only-child) {
    &:not(:last-child) {
      border-bottom-right-radius: 0;
      border-top-right-radius: 0;
    }
    &:not(:first-child) {
      border-bottom-left-radius: 0;
      border-top-left-radius: 0;
      margin-left: -1px;
      & [data-combo-button-overflow] {
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
      }
    }
  }
  &[data-variant='secondary'] {
    > *[aria-pressed='true'] {
      background: ${backgroundColors.backgroundInteractive};
      color: ${textColors.textInteractiveHover};
      border-color: ${borderColors.borderInteractiveSubtle};
      &:focus {
        border-color: ${colors.borderInteractiveStrong};
      }
      svg[data-temporary-fix] path {
        fill: ${textColors.textInteractiveHover};
      }
    }
    > *[aria-pressed='true']:focus,
    > *:focus-visible {
      /**
        Z-indexes are applied to ensure that focus state isn't covered by the sibling element.
      */
      &:nth-child(1) {
        z-index: 2;
      }
      &:nth-child(2) {
        z-index: 3;
      }
      &:nth-child(3) {
        z-index: 4;
      }
      &:nth-child(4) {
        z-index: 5;
      }
    }
  }
`;
